import authInstance from "../utilities/axios/authInstance";

export const allPatrolLogs = () => authInstance.get('patrol-logs');